<template>
  <div class="map-wrapper" :style="{ width: '100%', height: '100%' }">
    <div
      :id="`mapDropSpot-${current}`"
      :style="{ width: '100%', height: '100%' }"
    ></div>
    <!-- <div v-show="noData" class="background"></div>
    <div v-show="noData" class="dialog">
      周辺スポットが見つかりませんでした。

      <ButtonTextLink
        class="gotohere"
        text="検索画面に戻る"
        @click-text="onClickBackSearch"
      />

      <ButtonTextLink
        v-show="search.departure !== search.destination"
        class="gotohere"
        text="ルート結果画面へ進む"
        @click-text="onClickNoDrop"
      />
    </div> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";
import Firebase from "./../../firebase";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "GoogleMap",
  components: {
    ButtonTextLink,
  },
  props: {
    current: { type: String, default: false, required: true },
    isGetOriginalApiData: { type: Boolean, default: true, required: true },
  },
  computed: {
    ...mapState([
      "search",
      "registrationId",
      "DepLatLng",
      "DesLatLng",
      "currentLat",
      "currentLng",
      "originalApiData",
      "selectedSpotType",
      "selectedFilter",
    ]),
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
    currentOriApiData() {
      if (this.current === "RouteSearch") {
        return this.originalApiData.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.originalApiData.jyutai;
      }
    },
    currentSelectedSpotType() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotType.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotType.jyutai;
      }
    },
    currentSelectedFilter() {
      if (this.current === "RouteSearch") {
        return this.selectedFilter.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedFilter.jyutai;
      }
    },
  },
  data() {
    return {
      latlng: null,
      map: null,
      markers: [],
      routeMarkers: [],
      mapSpots: [],
      noData: false,
    };
  },
  methods: {
    ...mapMutations([
      "setOriginalApiData",
      "setSelectedSpotData",
      "loadingStartMini",
      "loadingEndMini",
      "setMap",
      "setDropDestionaton",
      "setDesLatLng",
      "setSearchState",
    ]),
    onClickBackSearch() {
      this.setDesLatLng(undefined);
      this.setSearchState("search");
    },
    onClickNoDrop() {
      this.setDropDestionaton({
        latlng: this.DesLatLng,
        name: this.currentSearch.destination,
      });

      this.setSearchState("result");
    },
    resetMapSpots() {
      this.resetMarkers();
      this.mapSpots = [
        {
          id: 1,
          type: "観光",
          list: [],
        },
        {
          id: 2,
          type: "温泉",
          list: [],
        },
        {
          id: 3,
          type: "食事",
          list: [],
        },
        {
          id: 4,
          type: "体験",
          list: [],
        },
        {
          id: 5,
          type: "お土産",
          list: [],
        },
      ];
    },
    loadMap() {
      this.loadingStartMini();
      return new Promise((resolve) => {
        const element = document.getElementById(`mapDropSpot-${this.current}`);
        this.latlng = new window.google.maps.LatLng(36.65, 138.18);
        const mapOptions = {
          mapId: "75847128c63f5e96",
          zoom: 12,
          center: this.latlng,
          gestureHandling: "greedy",
          scaleControl: false,
          mapTypeControl: false,
          zoomControl: false,
          streetViewControl: false,
          fullscreenControl: false,
        };
        this.map = new window.google.maps.Map(element, mapOptions);
        this.setMap(this.map);
        const trafficLayer = new window.google.maps.TrafficLayer();
        trafficLayer.setMap(this.map);
        resolve();
      });
    },
    setDefaultMarker(position) {
      let marker = new window.google.maps.Marker({
        position,
        map: this.map,
      });
      this.routeMarkers.push(marker);
    },
    mappingCategory(data) {
      if (data.category.id === 1) return "観光";
      else if (data.category.id === 2) return "温泉";
      else if (data.category.id === 3) return "食事";
      else if (data.category.id === 4) return "体験";
      else if (data.category.id === 5) return "お土産";
    },
    mappingType(spotType) {
      if (spotType === "食事") return "restaurant";
      else if (spotType === "お土産") return "shopping";
      else if (spotType === "観光") return "camera";
      else if (spotType === "温泉") return "spa";
      else if (spotType === "体験") return "experience";
    },
    mappingCongestionNum(data) {
      if (data.reports && data.reports.length > 0) {
        return data.reports[0].congestion;
      }
      return 0;
    },
    mappingCongestionCord(data) {
      const congestionNum = this.mappingCongestionNum(data);
      if (congestionNum === 1) return "_blue";
      else if (congestionNum === 2) return "_green";
      else if (congestionNum === 3) return "_yellow";
      else if (congestionNum === 4) return "_red";
      else return "_blue";
    },
    onClose() {
      this.noData = false;
    },
    onClickNoDrop() {
      this.setSearchState("result");
      this.noData = false;
    },
    setMarker(data) {
      const spotType = this.mappingCategory(data);
      const spotTypeText = this.mappingType(spotType);
      const congestionCord = this.mappingCongestionCord(data);
      let name = "";
      let size = new window.google.maps.Size(30, 30);

      let missionsLength = 0;
      if (data.missions) {
        missionsLength = data.missions.length;
      }
      if (data.missions && missionsLength > 0) {
        name = spotTypeText + "_lock" + congestionCord + ".svg";
        size = new window.google.maps.Size(35, 35);
      } else {
        name = spotTypeText + "_circle" + congestionCord + ".svg";
      }

      let markerImage = {
        url: this.loadImg(name),
        size: size,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: size,
      };
      const marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(data.lat, data.lon),
        map: this.map,
        icon: markerImage,
      });

      // マーカーがクリックされた場合
      if (data) {
        marker.addListener("click", async () => {
          this.setSelectedSpotData(data);
        });
      }
      let list = this.mapSpots.filter((x) => x.type === spotType)[0];
      list.list.push(marker);
    },
    compareDistance(distance) {
      if (!this.currentSelectedFilter.distance) return true;
      return distance <= this.currentSelectedFilter.distance;
    },
    setFilter() {
      const currentLat =
        this.current === "RouteSearch"
          ? this.currentDesLatLng.lat()
          : this.currentDepLatLng.lat();
      const currentLng =
        this.current === "RouteSearch"
          ? this.currentDesLatLng.lng()
          : this.currentDepLatLng.lng();
      this.resetMapSpots();
      const filteredSpotList = this.currentOriApiData.filter((data) => {
        return (
          this.getIsDuplicate(
            this.currentSelectedFilter.tag,
            data.tag_spots.map((tag) => tag.tag.id),
          ) &&
          this.compareDistance(
            this.calcDistance(data.lat, data.lon, currentLat, currentLng),
          )
        );
      });

      filteredSpotList.forEach((data) => {
        this.setMarker(data);
      });

      this.setMarkersVisble();
    },
    calcDistance(targetLat, targetLng, currentLat, currentLng) {
      const R = Math.PI / 180;
      let tmpLat = targetLat;
      let tmpLng = targetLng;
      let tmpCurrentLat = currentLat;
      let tmpCrrentLng = currentLng;
      tmpCurrentLat *= R;
      tmpCrrentLng *= R;
      tmpLat *= R;
      tmpLng *= R;
      return (
        6371 *
        Math.acos(
          Math.cos(tmpCurrentLat) *
            Math.cos(tmpLat) *
            Math.cos(tmpLng - tmpCrrentLng) +
            Math.sin(tmpCurrentLat) * Math.sin(tmpLat),
        ) *
        1000
      );
    },
    getIsDuplicate(arr1, arr2) {
      if (this.currentSelectedFilter.tag.length === 0) return true;
      return (
        [...arr1, ...arr2].filter(
          (item) => arr1.includes(item) && arr2.includes(item),
        ).length > 0
      );
    },
    resetMarkers() {
      for (let spotlist of this.mapSpots) {
        for (let spot of spotlist.list) {
          spot.setVisible(false);
        }
      }
    },
    setMarkersVisble() {
      for (let spotlist of this.mapSpots) {
        for (let spot of spotlist.list) {
          spot.setVisible(spotlist.type === this.currentSelectedSpotType);
        }
      }

      const resultLength = this.mapSpots.filter(
        (x) => x.type === this.currentSelectedSpotType,
      )[0].list.length;

      // ログ処理
      // ログで性能落としたくないので非同期しない
      const actionParams = {
        category: this.mappingType(this.currentSelectedSpotType),
        start_lon: this.currentDesLatLng.lng(),
        start_lat: this.currentDesLatLng.lat(),
        resut_count: resultLength,
      };

      Firebase.putLog({
        ActionType: "SearchSpots",
        ActionParams: actionParams,
      });
    },
    setBounds() {
      const bounds = new window.google.maps.LatLngBounds();
      let counter = 0;

      for (let spotlist of this.mapSpots) {
        for (let spot of spotlist.list) {
          bounds.extend(spot.position);
          counter++;
        }
      }

      if (counter > 0) {
        this.map.panToBounds(bounds);
        this.map.fitBounds(bounds);
        this.map.setZoom(12);
      } else {
        bounds.extend(this.currentDesLatLng);
      }
    },
    setRoute() {
      this.setDefaultMarker(this.currentDepLatLng);
      this.setDefaultMarker(this.currentDesLatLng);
      const directionsDisplay = new window.google.maps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true,
        suppressPolylines: false,
      });
      directionsDisplay.setDirections(this.currentSearch.route);
    },
    loadImg(img) {
      return require(`@/assets/spots/${img}`);
    },
    getOriginalApiData() {
      this.loadingStartMini();
      let setOriginalApiData = this.setOriginalApiData;
      let setFilter = this.setFilter;
      let setBounds = this.setBounds;
      let loadingEndMini = this.loadingEndMini;
      let param = {
        api_key: "i73rauGTyfewa",
        lat: this.currentDesLatLng.lat(),
        lng: this.currentDesLatLng.lng(),
        registration_id: this.registrationId,
      };

      if (this.current === "JyutaiSearch") {
        param = {
          api_key: "i73rauGTyfewa",
          lat: this.currentDepLatLng.lat(),
          lng: this.currentDepLatLng.lng(),
          registration_id: this.registrationId,
        };
      }

      axios
        .get(
          "https://mission-kqxgrnovcq-uc.a.run.app/api/spots",
          { params: param },
        )
        .then(async (response) => {
          if (response.data.length === 0) {
            this.noData = true;
          }
          await setOriginalApiData(response.data);
          await setFilter();
          await setBounds();
          loadingEndMini();
        })
        .catch(() => {
          this.noData = true;
          loadingEndMini();
        });
    },
  },
  async mounted() {
    this.loadingStartMini();
    this.resetMapSpots();
    await this.loadMap();
    this.setRoute();
    this.loadingEndMini();
    if (this.isGetOriginalApiData) {
      this.getOriginalApiData();
    }
  },
  watch: {
    currentSelectedSpotType: {
      immideate: true,
      handler: function () {
        this.setMarkersVisble();
      },
    },
    currentSelectedFilter: {
      immideate: true,
      handler: function () {
        this.getOriginalApiData();
      },
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  position: relative;
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: 80vw;
  padding: 1rem;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/GoogleMap.vue